<div class="row" *ngIf="product">
  <div class="col-md-12">
    <div class="row f-details single-wheel">
      <div class="col-md-5 col-lg-3 col-xl-3 col-12 ps-0">
        <a [routerLink]="['/', product.slug, product.sku]" class="img-wrap">
          <img *ngIf="product.images" [src]="product.images[0] | imagePath" class="img-fluid" alt="img" />
          <img *ngIf="!product.images" [src]="'/placeholder.png' | imagePath" class="img-fluid" alt="img" />
        </a>
      </div>


      <div class="col-md-7 col-lg-9 col-xl-9 col-12">
        <div class="" *ngIf="route.snapshot.url[0].path=='search-by-size'">

          <div class="product-top align-items-center">
            <div class="col-md-12 col-lg-6 col-sm-12 col-xs-12 pl-0">
              <h3 class="bold m-0">{{ product?.brand?.name }} </h3>
              <h5>{{ product?.model?.name }} {{
                product?.finish?.finish}}</h5>

            </div>

            <div class="col-md-12 col-lg-6 col-sm-12 col-xs-12 pl-0">
              <div class="increase-font2 p-0 d-flex justify-content-end">
                <span class="bold npc pb">Set of 4:</span>
                <span class="ml-3 bold npc pb">{{getSetOfFourPrice(product) | currency:
                  product?.vendor?.currency:'symbol'}}</span>
              </div>
            </div>

          </div>
          <div class="row" style="position: relative;z-index: 0;">
            <div class="col-12 col-sm-5 col-lg-6  col-md-12">
              <h3>Front Size</h3>
              <p class="f2"> <span>SKU:</span> <span class="text-black text-du"> {{product.sku}}</span></p>
              <p class="f2"> <span>Size:</span> {{product.size}} </p>
              <p class="f2"> <span>Bolt Pattern:</span> {{product.bolt_pattern}} </p>
              <p class="f2 hub_bore" [ngClass]="show_center_bore == true ? '' : 'd-none'"> <span>Hub Bore:</span> {{ product.hub_bore }} </p>
              <p class="f2"> <span>Offset:</span> {{ product.offset }} </p>
              <p class="f2 wheel_weight" [ngClass]="show_wheel_weight == true ? '' : 'd-none'"> <span>Weight:</span> {{ product.weight }} </p>
              <p class="f2"> <span>MSRP</span> {{ product?.us_retail_price | currency:
                product?.vendor?.currency:'symbol' }}/each </p>
              <p class="f2" *ngIf="product.rear_clearance_corner"> <span>Sale Price:</span> {{
                product?.price | currency: product?.vendor?.currency:'symbol' }} </p>
              <p class="f2 bold-p" *ngIf="product.discounted_price > 0 && listPshow && !is_hide_cost"> <span class="text-black"> Your
                  Price:</span> {{ product?.discounted_price | currency:
                product?.vendor?.currency:'symbol' }}/each </p>
              <div class="row mb-3">
                <div *ngIf="product.total_quantity>0" class="col-md-12">
                  <p class="f2 text-du mt-2 bold-p"  data-toggle="modal"
                    [attr.data-target]="'#stockModal-' + product.id+ '-' + product.product_variant_id"
                    (click)="getInventoryByProduct(product.id, product.product_variant_id)">{{product.total_quantity}}
                    in stock</p>
                </div>
                <div class="d-flex align-items-center pb-sm-0 pt-2 w-100 justify-content-end"
                  *ngIf="product.total_quantity == 0">
                  <p class="mb-0 text-left" style="cursor: pointer;text-decoration:underline" data-toggle="modal"
                    [attr.data-target]="'#stockModal-' + product.id+ '-' + product.product_variant_id"
                    (click)="getInventoryByProduct(product.id, product.product_variant_id)">
                    {{product.product_inventory[0]?.eta}}</p>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-5 col-lg-6 col-md-12" *ngIf="isRear && product.rear_size!=null">
              <h3 class="text-uppercase">Rear Size</h3>
              <p class="f2"> <span>SKU:</span> <span class="text-black text-du"> {{product?.rear_sku}}</span> </p>
              <p class="f2"> <span>Size:</span> {{product.rear_size}} </p>
              <p class="f2"> <span>Bolt Pattern:</span> {{product.rear_bolt_pattern}} </p>
              <p class="f2 hub_bore" [ngClass]="show_center_bore == true ? '' : 'd-none'"> <span>Hub Bore:</span> {{ product.hub_bore }} </p>
              <p class="f2"> <span>Offset:</span> {{ product.rear_offset }} </p>
              <p class="f2 wheel_weight" [ngClass]="show_wheel_weight == true ? '' : 'd-none'"> <span>Weight:</span> {{ product.weight }} </p>
              <p class="f2"> <span>MSRP</span> {{ product?.rear_us_retail_price | currency:
                product?.vendor?.currency:'symbol' }}/each </p>
              <p class="f2" *ngIf="product.rear_clearance_corner"> <span>Sale Price:</span> {{
                product?.rear_price | currency: product?.vendor?.currency:'symbol' }} </p>
              <p class="f2 bold-p" *ngIf="product.rear_discounted_price > 0 && listPshow && !is_hide_cost"> <span class="text-black">Your
                  Price:</span> {{ product?.rear_discounted_price | currency:
                product?.vendor?.currency:'symbol' }}/each </p>

              <!-- <h6 class="hide-small">$ {{product.rear_uae_retail_price | number: '1.2-2' }}/each</h6> -->


              <div class="row  mb-3">
                <div *ngIf="product.total_quantity>0 && product.rear_in_stock_quantity>0" class="col-md-12">
                  <p class="mb-0 f2 text-du mt-2 bold-p" data-toggle="modal"
                    [attr.data-target]="'#stockModal-' + product.id+ '-' + product.product_variant_id"
                    (click)="getInventoryByProduct(product.rear_product_id, product.rear_varient_id)">{{product.rear_in_stock_quantity}}
                    in stock</p>
                </div>
                <div class="d-flex align-items-center pb-sm-0 pt-2 w-100 justify-content-end"
                  *ngIf="product.rear_in_stock_quantity == 0">
                  <p class="mb-0 text-left" style="cursor: pointer;text-decoration:underline" data-toggle="modal"
                    [attr.data-target]="'#stockModal-' + product.id+ '-' + product.product_variant_id"
                    (click)="getInventoryByProduct(product.rear_product_id, product.rear_varient_id)">
                    {{product.product_inventory[0]?.eta}}</p>
                </div>
              </div>
            </div>


          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade stock-modal" id="stockModal-{{product.id}}-{{product.product_variant_id}}" tabindex="-1"
  role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h5 class="modal-title" id="exampleModalLabel">Inventory</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body border-0">
        <div class="d-flex flex-row align-items-center justify-content-center inventory_loader">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <span>&nbsp;&nbsp;Fetching Data ...</span>
        </div>
        <div class="table-responsive inventory_table">
          <table class="table cart-table">
            <thead>
              <tr>
                <th>Warehouse</th>
                <th>Quantity</th>
                <th>Ship From</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let inventory of inventoryData; let i = index">
                <tr *ngIf="inventory.quantity>0">
                  <td>{{inventory.warehouse_name}}</td>
                  <td>
                    <span>{{ inventory.quantity }}</span>
                  </td>
                  <td>
                    <input type="radio" name="stock-{{product.id}}" [checked]="i === 0"
                      (change)="setWarehouse(clickedProductID, inventory.id, false)" />
                  </td>
                </tr>
                <tr *ngIf="inventory.eta">
                  <td>{{inventory.warehouse_name}}</td>
                  <td>
                    <span>{{ inventory.eta_qty }} {{
                      inventory.eta}}</span>
                  </td>
                  <td>
                    <input type="radio" name="stock-{{product.id}}" [checked]="i == 0 && inventory.quantity == 0"
                      (change)="setWarehouse(clickedProductID, inventory.id, true)" />
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>
</div>